

  <template>
  <div>
    <iModal
      v-model="showModal"
      class-name="vertical-center-modal my-choice-modal"
      width="900px"
      :footer-hide="true"
      :mask-closable="false"
      @on-cancel="$emit('close')"
      :styles="{top: '100px'}"
    >
      <div class="choice">
        <div class="choice-line">
          <span class="choice-line-title">全部</span>
          <Form ref="formInline" inline class="choice-form">
            <FormItem>
              <DatePicker
                type="daterange"
                placeholder="按时间"
                style="width: 100%"
                @on-change="timeChange"
              ></DatePicker>
            </FormItem>
            <FormItem>
              <Select v-model="city" placeholder="按城市" filterable @on-change="change" clearable>
                <Option
                  v-for="item in cityArr"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Select v-model="industry" placeholder="按行业" filterable @on-change="change" clearable>
                <Option
                  v-for="item in industryArr"
                  :value="item.name"
                  :key="item.name"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Form>
        </div>
        <div class="choice-box" v-if="list && list.items && list.items.length">
          <Row :gutter="10">
            <Col span="12" v-for="(item, index) in list.items" :key="index">
              <div
                class="choice-box-item"
                @click="setEx2(item)"
                :class="{active: (exhibition && exhibition.id) === item.id}"
              >
                <div class="cbi-l">
                  <img :src="item.logo" v-if="item.logo" />
                  <img src="@/assets/img/empty.png" v-else />
                </div>
                <div class="cbi-c">
                  <div class="name" :title="item.name">{{item.name}}</div>
                  <div
                    class="info"
                  >时间：{{item.startTime | moment("YYYY/MM/DD")}}~{{item.endTime | moment("YYYY/MM/DD")}}</div>
                  <div class="info" :title="item.address">地点：{{item.address}}</div>
                </div>
                <div class="cbi-r">
                  <span v-if="item.orderIndex === 1" class="status s-1">正在开展</span>
                  <span v-if="item.orderIndex === 2" class="status s-2">即将开展</span>
                  <span v-if="item.orderIndex === 3" class="status s-3">结束</span>
                </div>
                <div class="cbi-layer">
                  <i class="icon iconfont icon-iconfontcheck"></i>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="u-empty" v-else>暂无数据</div>
      </div>
      <div class="footer" v-if="totalCount > pageSize">
        <div class="my-page">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div>
        <div class="choice-box2">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="110"
            @submit.native.prevent
          >
            <FormItem label="展品类别：" prop="type">
              <Select
                v-model="formInline.type"
                filterable
                placeholder="展品类别"
                multiple
                @on-change="selectChange"
              >
                <Option
                  v-for="item in exTypeArr"
                  :value="item.name"
                  :key="item.name"
                >{{ item.name }}</Option>
              </Select>
            </FormItem> 
            <Row v-for="(booth, index) in formInline.boothInfo" :key="'boothInfo-' + index">
              <Col span="11"> 
                <FormItem label="展馆编号：" prop="type">
                  <Select v-model="booth.Hall" filterable>
                    <Option
                      v-for="item in exHallArr"
                      :value="item.name"
                      :key="item.name"
                    >{{ item.name }}</Option>
                  </Select>
                </FormItem>
              </Col> 
              <Col span="11">
                <FormItem label="展位编号：" prop="time">
                  <Input v-model="booth.Code" />
                </FormItem>
              </Col>
              <Col span="2" class="ie-icon">
                <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addBootArr()" />
                <Icon
                  type="ios-remove-circle-outline"
                  v-else
                  style="color: red;"
                  @click="delBootArr(index)"
                />
              </Col>
            </Row>
            
            <FormItem label="展位面积：" prop="name">
              <InputNumber :max="999" :min="1" v-model="formInline.area" style="width: 227px;"></InputNumber>
              <span style="display: inline-block;padding-left: 5px;"></span>单位：m²
            </FormItem>
          </Form>
        </div>
        <div class="choice-btnbox">
          <Button type="primary" @click="handleSubmit('formInline')" :loading="loading">确定</Button>
          <span style="display: inline-block;padding-left:  5px;"></span>
          <Button @click="close">取消</Button>
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "exhibition-choice-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultExhibition: null,
      exhibition: null,
      value2: ["2016-01-01", "2016-02-15"],
      time: [null, null],
      loading: false,
      showModal: false,
      pageSize: 12,
      pageIndex: 1,
      totalCount: 0,
      cityArr: [],
      industryArr: [],
      city: "",
      industry: "",
      list: [], // 展会列表

      joinInfo: null,
      formInline: {
        // form双向绑定
        type: [],
        hall: null,
        num: "",
        time: "",
        area: 0, 
        boothInfo: [{ Hall: "", Code: "" }]
      },
      ruleInline: {
        num: [{ required: true, message: "展位号不能为空", trigger: "blur" }]
      },
      exTypeArr: [], // 展商类别
      exHallArr: [],
      categories: []
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      let opt = {
        Wheres: {
          Type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: []
          }
        }
      };
      if (this.industry) {
        opt.Wheres.Wheres.Predicates.push({
          type: 1,
          wheres: {
            WhereOperator: 6,
            Label: "Industry",
            Value: `%${this.industry || ""}%`
          }
        });
      }
      if (this.city) {
        opt.Wheres.Wheres.Predicates.push({
          type: 1,
          wheres: {
            WhereOperator: 6,
            Label: "City",
            Value: `%${this.city || ""}%`
          }
        });
      }
      if (this.time && this.time.length && this.time[0]) {
        opt.Wheres.Wheres.Predicates.push({
          type: 2,
          wheres: {
            Label: "StartTime",
            Value: {
              Value1: this.time[0] || "",
              Value2: this.time[1] || ""
            }
          }
        });
      }
      return opt;
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    exhibition(val, oldVal) {
      if (val) {
        if (this.$route.query && this.$route.query.type !== "add") {
          this.init2(val.id);
        }
      }
    }
  },
  async created() {
    let data = await this.getIndustryListAndChildren();
    if (data && data.length) {
      this.industryArr = data;
    }
    this.init();
    this.getDefaultEx();
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition",
      setJoinEx: "companyModule/setJoinEx"
    }),
    ...mapActions({
      getIndustryListAndChildren: "exhibitionModule/getIndustryListAndChildren",
      getExhibitionAll: "exhibitionModule/getExhibitionAll",

      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      getJoinExhibitionInfoByCompId:
        "exhibitionModule/getJoinExhibitionInfoByCompId",

      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getJoinById: "exhibitionModule/getJoinById"
    }),
    async getDefaultEx() {
      const query = this.$route.query;
      let ex = null;
      let res = await this.getJoinById(query.editId);
      if (res && res.exhibitionId) {
        this.setJoinEx(res);
        ex = await this.getExhibitionById(res.exhibitionId);
      }
      if (ex && ex.id) {
        if (this.$route.query && this.$route.query.type !== "add") {
          this.defaultExhibition = ex;
          this.setEx(ex);
        }
      }
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async init() {
      let list = await this.getExhibitionAll(this.option);
      if (list) {
        this.list = list;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    change(e) {
      this.pageIndex = 1;
      this.init();
    },
    timeChange(e) {
      this.time = e;
      this.init();
    },

    setEx(item) {
      if (item) {
        this.setExhibition(item);
        this.exName = item.name;
        this.exhibition = item;
        this.init2(this.exhibition.id);

        this.exHallArr = [];
        this.exTypeArr = [];
        this.formInline.boothInfo = [{ Hall: "", Code: "" }];
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
      }
    },
    async setEx2(item) {
      let data = null;
      if (item && !this.exhibition) {
        // 选择展会且没有没有参加展会时
        data = await this.getJoinExhibitionInfoByCompId({
          compId: this.company.id,
          exhibitionId: item.id
        });
      }
      if (data) {
        this.$Message.warning("已参加过当前展会");
        return;
      }
      if (
        this.exhibition &&
        this.$router.history.current.query.type !== "add"
      ) {
        return;
      }
      if (item) {
        this.setExhibition(item);
        this.exName = item.name;
        this.exhibition = item;
        this.init3(this.exhibition.id);

        this.exHallArr = [];
        this.exTypeArr = [];
        this.formInline.boothInfo = [{ Hall: "", Code: "" }];
        this.formInline.type = [];
        this.formInline.hall = null;
        this.formInline.num = "";
      }
    },

    addBootArr() {
      this.formInline.boothInfo.push({ Hall: "", Code: "" });
    },
    delBootArr(i) {
      this.formInline.boothInfo.splice(i, 1);
    },
    async init2(id) {
      let hallData = await this.getHallByExhibition(id);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }
      let categoryData = await this.getCategoryByExhibition(id);
      if (categoryData && categoryData.length) {
        this.exTypeArr = categoryData;
      } else {
        this.exTypeArr = [];
      }
      if (
        (this.exHallArr && this.exHallArr.length) ||
        (this.exTypeArr && this.exTypeArr.length)
      ) {
        this.getInfo();
      } else {
        this.formInline.hall = null;
        this.formInline.num = "";
      }
    },
    async init3(id) {
      let hallData = await this.getHallByExhibition(id);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }
      let categoryData = await this.getCategoryByExhibition(id);
      if (categoryData && categoryData.length) {
        this.exTypeArr = categoryData;
      } else {
        this.exTypeArr = [];
      }
    },
    async getInfo() {
      // 通过公司和展会id获取参展信息
      let data = await this.getJoinExhibitionInfoByCompId({
        compId: this.company.id,
        exhibitionId: this.exhibition.id
      });
      if (data) {
        data.categories = data.categories ? JSON.parse(data.categories) : [];
        data.compInfo = data.compInfo ? JSON.parse(data.compInfo) : null;
        data.exInfo = data.exInfo ? JSON.parse(data.exInfo) : null;
        this.formInline.area = data.boothArea || 0;
        let boothInfo = data.boothInfo;
        if (boothInfo && boothInfo.indexOf("[") !== -1) {
          this.formInline.boothInfo = JSON.parse(boothInfo);
          if (this.formInline.boothInfo.length === 0) {
            this.formInline.boothInfo = [{ Hall: "", Code: "" }];
          }
        }
      }
      if (
        data &&
        data.categories &&
        data.categories.length &&
        this.exTypeArr &&
        this.exTypeArr.length
      ) {
        this.exTypeArr.forEach(v => {
          data.categories.forEach(c => {
            if (c.Value === v.name) {
              this.formInline.type.push(c.Value);
            }
          });
        });
      }
      if (data && data.exHall) {
        this.formInline.hall = data.exHall;
      }
      if (data && data.boothCode) {
        this.formInline.num = data.boothCode;
      }
      if (data && data.categories) {
        this.formInline.type = data.categories;
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!this.formInline.boothInfo && !this.formInline.boothInfo.length) {
        this.$Message.error("展馆信息不能为空！");
      }
      this.categories = [];
      this.exTypeArr.forEach(v => {
        this.formInline.type.forEach((c, index) => {
          if (c === v.name && index <= 2) {
            this.categories.push(v.name);
          }
        });
      });
      if (this.categories && this.categories.length === 0) {
        this.$Message.error("产品类别不能为空！");
        return;
      }
      this.$emit("change", {
        Categories: this.categories,
        ExHall: this.formInline.hall || [],
        BoothCode: this.formInline.num,
        BoothInfo: this.formInline.boothInfo,
        ExhibitionId: this.exhibition.id,
        BoothArea: this.formInline.area || 0,
        Exhibition: this.exhibition
      });
      setTimeout(() => {
        this.$emit("close");
      }, 400);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.$emit("close");
    },
    selectChange(e) {
      if (e && e.length > 3) {
        this.formInline.type = [e[0], e[1], e[2]];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ie-icon {
  line-height: 31px;
  padding-left: 30px;
  .ivu-icon {
    font-size: 22px;
    cursor: pointer;
    font-size: 22px;
    color: #118eea;
  }
  &.z-remove {
    color: #d71f06;
  }
}
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 900px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
<style lang="scss">
.my-choice-modal {
  .ivu-modal-body {
    padding: 16px 0 0;
  }
}
.choice {
  min-height: 500px;
  padding-top: 40px;
  &-line {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &-title {
      width: 94px;
      text-align: center;
      font-size: 16px;
      color: #333;
    }
    .ivu-form-item {
      margin-bottom: 0;
    }
  }
  &-form {
    padding-right: 10px;
    display: flex;
    .ivu-form-item {
      flex: 1;
    }
    flex: 1;
  }
  &-box {
    height: 500px;
    padding: 10px 20px;
    overflow: auto;
    &-item {
      height: 110px;
      border-radius: 5px;
      border: solid 1px rgba(221, 221, 221, 0.3);
      padding: 20px 18px;
      display: flex;
      margin-bottom: 10px;
      cursor: pointer;
      transition: all 0.3s;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: rgba(221, 221, 221, 0.6);
      }
      &.active {
        .cbi-layer {
          display: block;
        }
      }
    }
  }
  &-box2 {
    border-top: 1px solid #ddd;
    padding: 14px 30px 0 0;
  }
  &-btnbox {
    text-align: right;
    padding: 12px 20px;
    border-top: 1px solid #ddd;
  }
  .cbi {
    display: flex;
    &-l {
      margin-right: 16px;
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border: solid 1px #e6e6e6;
        border-radius: 50%;
      }
    }
    &-layer {
      background-color: rgba(0, 0, 0, 0.3);
      display: none;
      position: absolute;
      padding-top: 30px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
      text-align: center;
      .iconfont {
        font-size: 30px;
        color: #fff;
      }
    }
    &-c {
      margin-right: 16px;
      flex: 1;
      .name {
        font-size: 16px;
        color: #262626;
        margin-bottom: 14px;
        width: calc(100% - 1px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info {
        width: calc(100% - 1px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #8c8c8c;
      }
    }
    &-r {
      display: flex;
      align-items: center;
      width: 70px;
      .status {
        display: inline-block;
        color: #fff;
        padding: 2px 6px;
        &.s-1 {
          background-color: #1890ff;
        }
        &.s-2 {
          background-color: #fe791e;
        }
        &.s-3 {
          background-color: #999;
        }
      }
    }
  }
}
.footer {
  text-align: center;
  padding-top: 20px;
}
</style>